import axios, { AxiosResponse } from 'axios';
import translations from '@/assets/json/translations.json';

const baseWordpressApiUrl: string = `${process.env.VUE_APP_WORDPRESS_API_URL}`;

export default {
  getAllPortalTranslations(): Promise<AxiosResponse> {
    return axios.get(`${ baseWordpressApiUrl }/wp-json/v1/translations`);
  },
  getAllTranslationsFromFile(): Promise<any> {
    return new Promise((resolve) => {
      resolve(translations);
  });
  },
};
